/**
 * Created by jonas on 2021-03-04.
 */
import {DasUBootSymbolStates} from "../DasUBootSymbol";
import {gsap} from "gsap";
import {DasUBoot} from "../../DasUBoot";
import {DasUBootGameAssets} from "../../DasUBootGameAssets";
import {DasUBootReel} from "../DasUBootReel";
import {DasUBootSound} from "../../sound/DasUBootSound";
import {SpineSymbol} from "./SpineSymbol";

export function isPeriscopeSymbol(value:any):value is PeriscopeSymbol {
    return value.symbolName === "P";
}


export class PeriscopeSymbol extends SpineSymbol {

    private extended:boolean = false;

    constructor(reel:DasUBootReel, symbolName:string) {
        super(reel, symbolName, DasUBootGameAssets.PERISCOPE_SYMBOL_SPINE);
    }

    destroy(options?:{children?:boolean; texture?:boolean; baseTexture?:boolean}) {
        const tl = gsap.timeline();
        tl.add(gsap.to(this,{duration:0.05}));
        tl.add(()=>super.destroy(options));
    }

    public getStateAnimation(state:DasUBootSymbolStates):gsap.core.Timeline {
        let tl:gsap.core.Timeline = gsap.timeline();

        switch (state) {
            case DasUBootSymbolStates.LANDING:
                tl = super.getStateAnimation(state);
                if (this.isVisibleInReel()) {
                    tl.add(this.getSpineAnimation(PeriscopeSymbol.getLandingAnimationName(), 0, false));

                    tl.add(()=>{
                        this.moveToWinLayer();
                        DasUBoot.soundPlayer.playSingleSound(DasUBootSound.PERISCOPE_SYMBOL_LANDING);
                        DasUBoot.reelView.getLandingShake(false).play(0);
                    },0.001);

                    tl.add(()=>this.removeSpineFromView());
                }
                break;
            case DasUBootSymbolStates.EXPAND:
                this.extended = true;
                tl.add(() => this.moveToNormalLayer(true));
                tl.add(() => DasUBoot.soundPlayer.playSingleSound(DasUBootSound.PERISCOPE_SYMBOL_EXPANDING));
                tl.add(this.getSpineAnimation("expand", 0, false));
                break;
            default:
                tl = super.getStateAnimation(state);
        }

        this._stateAnimation = tl;
        return tl;
    }


    private static getLandingAnimationName():string {
        if (DasUBoot.model.gameData?.periscope?.hasScope === true) {
            return "landingHit"
        }
        return "landingWild";
    }
}